<template>
<div id="faq"> 
           <span class="Maintitle"> 
            <i class="fas fa-clinic-medical"></i>
            <strong> Vaccine Portal </strong> 
       </span> 
       <span class=""> 
        <h4><small class="text-muted">
                <i class="far fa-question-circle"></i>
                <strong> Frequently Asked Questions : </strong> 
        </small></h4>  
        </span> 
<div class="ml-0">
 
<!-- <div v-b-toggle.collapse-a.collapse-b class="card-title pointer row  ml-1 Maintitle">  -->
<div v-b-toggle.collapse-1 class="card-title pointer row  ml-1 mr-1 Maintitle">
     <kbd>1</kbd><span >Vaccine Portal User Guide</span>
</div> 
<b-collapse visible id="collapse-1" class="mb-2 ml-1">
    <!-- <a href="/Covid-Risk-UserGuide.pdf"> download </a> -->
    <!-- <b-card style="text-decoration:underline"><a v-on:click="showGuide">Field Hospital Application User Guide</a></b-card> -->
    <b-card ><a class='pointer' style="text-decoration:underline" v-on:click="DownloadFile">Vaccine Portal User Guide</a></b-card>
    

</b-collapse>
 
</div>
 
</div>
</template>
<script> 
 import axios from "axios";
 import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import Subtitle from '@/Common/Default/SubTitle.vue'; 
import Accordion from '@/Common/Default/Accordion.vue'; 
import { FhUserguidePath } from '@/Docs/UserguidePath';
export default  {
     props:{
        
     },  
  data: function () {
      
    return {
              text: '',
              FhUserguidePath : FhUserguidePath
        }
    },
    components: { 
              Card,
            CardBody,
            TileNote,
            Subtitle ,
            Accordion           
        },
    mounted: function () {
    this.$nextTick(function () {  
    })
    },
    created: function() { 
       // this.$emit('update:layout', FaqLayout);
        //////console.log('at Dental Main home')
        //this.menuitems = this.$store.getters.GetMainMenu; 
    },
    computed:{  
    },
    watch: { 
    },
    methods: {
     DownloadFile: function () {
      var vm = this;
      var filename = "Covid-Risk-UserGuide.pdf";
      var url = "/SaskHealthApi/Codes/GetUserGuide?_=";
      axios
        .get(url + Date.now(), {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          responseType: 'blob' ,
        })
        .then(function (response) {
        if (typeof window.chrome !== 'undefined') { 
            const pdfBlob = new Blob([response.data], { type: "application/pdf" }) 
            const blobUrl = window.URL.createObjectURL(pdfBlob)
            const link = document.createElement('a')
            link.href = blobUrl
            link.setAttribute('download', filename)
            link.click();
            link.remove();
            URL.revokeObjectURL(blobUrl); 
   
        } else if (typeof window.navigator.msSaveBlob !== 'undefined') {
            // IE version
            var blob = new Blob([response.data], { type: 'application/pdf' });
            window.navigator.msSaveBlob(blob, filename);
        } else {
            // Firefox version
            var file = new File([response.data], filename, { type: 'application/force-download' });
            window.open(URL.createObjectURL(file));
        }
       })
        .catch(function (er) {
          if (er.status == 404) {
            //console.log("at 404");
            vm.showMsg(
              "File not found, please contact system admin for more detail.",
              "",
              "User Guide File Error"
            );
          } else if (er.status == 400) {
            vm.showMsg(
              "File not found, please contact system admin for more detail.",
              "",
              "User Guide File Error"
            );
          } else if (er.status == 500) {
            vm.showMsg(
              "Network Error: Please contact system admin for more detail.",
              "",
              "User Guide File Error"
            );
          }
          //console.log(er);
        });
    },
        // showGuide: function(){
        // var pdf = '/src/assets/FH-UserGuide.docx';
        // window.open(pdf);
        // },
      showGuide:function(){ 
        const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];        
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        const blob = new Blob(byteArrays, {type: contentType});
        return blob;
        }  
 
        const contentType = 'application/pdf';
        const blob = b64toBlob(FhUserguidePath.Userguide , contentType); 
        const fileName = 'Covid-Risk-UserGuide'; 
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            var byteCharacters = atob(FhUserguidePath.Userguide);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i=0;i<byteCharacters.length;i++){
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            var blobIE = new Blob([byteArray],{type: 'application.pdf'});
            window.navigator.msSaveOrOpenBlob(blobIE,fileName);
        }
        else
        {
            //////console.log("open _blank"); 
            var win = open('', '_blank'); 
            win.document.write(
                '<html><body><center>' +
                '<a title="Download pdf" style="font-family: \'Verdana\';color: #333;text-decoration: none;font-weight: 600;" download="' + fileName + '" href="data:application/pdf;base64,' + FhUserguidePath.Userguide + '">Download User Guide</a>' +
                '</center><br>' +
                '<object width=100% height=100% type="application/pdf" data="data:application/pdf;base64,' + FhUserguidePath.Userguide  + '">' +
                '<embed type="application/pdf" src="data:application/pdf;base64,' + FhUserguidePath.Userguide  + '" id="embed_doc"></embed>' +
                '</object></body></html>'); 
            } 
        },
    
    HideMsg: function(val){
 
        },
    showMsg1(msg,data,Title) {
        this.boxTwo = ''
        this.$bvModal.msgBoxOk(msg, {
        title: Title,
        size: 'md',
        buttonSize: 'md',
        okVariant: 'primary',          
        okTitle: 'Close', 
        footerClass: 'p-2',
        hideHeaderClose: true,
        hideHeaderCancel: true,
        centered: true, 
        }); 
      }, 
    },
}
</script>
<style scoped>
 
</style>

